(function () {
  "use strict";

  /* Header: transparent over hero, solid on scroll (mirrors Header.tsx) */
  var header = document.querySelector("[data-lv-header]");
  if (header) {
    var overHero = header.getAttribute("data-over-hero") === "true";
    var burger = header.querySelector("[data-lv-burger]");
    var panel = header.querySelector("[data-lv-mobile]");

    function paint() {
      var open = panel && panel.classList.contains("is-open");
      var solid = !overHero || window.scrollY > 40 || open;
      header.classList.toggle("lv-header--solid", solid);
      header.classList.toggle("lv-navy-grad", solid);
    }
    paint();
    if (overHero) window.addEventListener("scroll", paint, { passive: true });

    if (burger && panel) {
      burger.addEventListener("click", function () {
        panel.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", panel.classList.contains("is-open"));
        paint();
      });
    }
  }

  /* Reveal on scroll (replaces Reveal.tsx) */
  var revealables = document.querySelectorAll(".lv-reveal");
  if (revealables.length) {
    if (!("IntersectionObserver" in window)) {
      revealables.forEach(function (el) { el.classList.add("is-in"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var d = parseInt(e.target.getAttribute("data-delay") || "0", 10);
          setTimeout(function () { e.target.classList.add("is-in"); }, d);
          io.unobserve(e.target);
        });
      }, { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
      revealables.forEach(function (el) { io.observe(el); });
    }
  }

  /* Hero slideshow: crossfade + ken burns (mirrors HeroSlider.tsx) */
  var hero = document.querySelector("[data-lv-hero]");
  if (hero) {
    var slides = hero.querySelectorAll(".lv-hero__img");
    var dots = hero.querySelectorAll(".lv-hero__dots button");
    var i = 0, timer = null;
    var INTERVAL = parseInt(hero.getAttribute("data-interval") || "5500", 10);

    function show(n) {
      i = n;
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === n); });
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === n); });
    }
    function next() { show((i + 1) % slides.length); }
    function start() { if (slides.length > 1) timer = window.setInterval(next, INTERVAL); }
    function stop() { if (timer) window.clearInterval(timer); timer = null; }

    dots.forEach(function (d, k) {
      d.addEventListener("click", function () { stop(); show(k); start(); });
    });
    if (slides.length) show(0);
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) start();
  }

  /* Upgrade native form selects to the same component as the hero search. */
  document.querySelectorAll(".lv-form select, .lv-step select").forEach(function (select, index) {
    if (select.closest("[data-lv-select]")) return;

    var root = document.createElement("div");
    root.className = "lv-select lv-enhanced-select";
    root.setAttribute("data-lv-select", "");

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "lv-select__btn";
    btn.setAttribute("data-lv-select-btn", "");
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");

    var value = document.createElement("span");
    value.className = "lv-select__value";
    value.textContent = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : "";
    btn.appendChild(value);

    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("width", "14");
    svg.setAttribute("height", "14");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "2");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "m6 9 6 6 6-6");
    svg.appendChild(path);
    btn.appendChild(svg);

    var panel = document.createElement("div");
    panel.className = "lv-select__panel";
    panel.setAttribute("role", "listbox");
    panel.hidden = true;

    Array.prototype.forEach.call(select.options, function (option) {
      var opt = document.createElement("button");
      opt.type = "button";
      opt.setAttribute("role", "option");
      opt.setAttribute("data-value", option.value);
      opt.setAttribute("aria-selected", option.selected ? "true" : "false");
      if (option.selected) opt.className = "is-on";
      var text = document.createElement("span");
      text.textContent = option.text;
      opt.appendChild(text);
      opt.appendChild(document.createElement("i"));
      panel.appendChild(opt);
    });

    var fieldLabel = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    if (fieldLabel) btn.setAttribute("aria-label", fieldLabel.textContent.trim());

    select.parentNode.insertBefore(root, select);
    root.appendChild(btn);
    root.appendChild(select);
    root.appendChild(panel);
    select.hidden = true;
    select.setAttribute("data-lv-select-input", "");
    select.setAttribute("tabindex", "-1");
    root.setAttribute("data-enhanced-index", index);
  });

  /* Custom selects (hero search and enhanced forms) */
  var selects = Array.prototype.slice.call(document.querySelectorAll("[data-lv-select]"));

  function closeAll(except) {
    selects.forEach(function (s) {
      if (s === except) return;
      s.removeAttribute("data-open");
      s.querySelector("[data-lv-select-btn]").setAttribute("aria-expanded", "false");
      s.querySelector(".lv-select__panel").hidden = true;
    });
  }

  selects.forEach(function (root) {
    var btn = root.querySelector("[data-lv-select-btn]");
    var panel = root.querySelector(".lv-select__panel");
    var input = root.querySelector("[data-lv-select-input]");
    var label = root.querySelector(".lv-select__value");
    var opts = Array.prototype.slice.call(panel.querySelectorAll("[role=option]"));

    function open() {
      closeAll(root);
      root.setAttribute("data-open", "");
      btn.setAttribute("aria-expanded", "true");
      panel.hidden = false;
      var on = panel.querySelector(".is-on") || opts[0];
      if (on) on.focus();
    }
    function close(focusBtn) {
      root.removeAttribute("data-open");
      btn.setAttribute("aria-expanded", "false");
      panel.hidden = true;
      if (focusBtn) btn.focus();
    }
    function choose(opt) {
      opts.forEach(function (o) {
        o.classList.remove("is-on");
        o.setAttribute("aria-selected", "false");
      });
      opt.classList.add("is-on");
      opt.setAttribute("aria-selected", "true");
      input.value = opt.getAttribute("data-value") || "";
      input.dispatchEvent(new Event("change", { bubbles: true }));
      label.textContent = opt.querySelector("span").textContent;
      close(true);
    }

    btn.addEventListener("click", function () {
      if (root.hasAttribute("data-open")) close(true); else open();
    });
    btn.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
    });
    opts.forEach(function (opt, i) {
      opt.addEventListener("click", function () { choose(opt); });
      opt.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { e.preventDefault(); close(true); }
        else if (e.key === "ArrowDown") { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
        else if (e.key === "ArrowUp") { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
        else if (e.key === "Home") { e.preventDefault(); opts[0].focus(); }
        else if (e.key === "End") { e.preventDefault(); opts[opts.length - 1].focus(); }
        else if (e.key === "Enter" || e.key === " ") { e.preventDefault(); choose(opt); }
      });
    });
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-lv-select]")) closeAll(null);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll(null);
  });

  /* Branded date picker for tour enquiry forms. */
  document.querySelectorAll("[data-lv-date]").forEach(function (root) {
    var btn = root.querySelector("[data-lv-date-btn]");
    var panel = root.querySelector("[data-lv-date-panel]");
    var input = root.querySelector("[data-lv-date-input]");
    var value = root.querySelector("[data-lv-date-value]");
    var month = root.querySelector("[data-lv-date-month]");
    var days = root.querySelector("[data-lv-date-days]");
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var view = new Date(today.getFullYear(), today.getMonth(), 1);
    var selected = null;
    var locale = document.documentElement.lang || "en-US";

    function iso(date) {
      return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0");
    }

    function sameDay(a, b) {
      return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }

    function render() {
      month.textContent = view.toLocaleDateString(locale, { month: "long", year: "numeric" });
      days.innerHTML = "";
      var first = view.getDay();
      var count = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var blank = 0; blank < first; blank++) {
        var spacer = document.createElement("span");
        spacer.setAttribute("aria-hidden", "true");
        days.appendChild(spacer);
      }
      for (var day = 1; day <= count; day++) {
        (function (dayNumber) {
          var date = new Date(view.getFullYear(), view.getMonth(), dayNumber);
          var dayBtn = document.createElement("button");
          dayBtn.type = "button";
          dayBtn.textContent = dayNumber;
          dayBtn.setAttribute("aria-label", date.toLocaleDateString(locale, { weekday: "long", month: "long", day: "numeric", year: "numeric" }));
          if (date < today) dayBtn.disabled = true;
          if (sameDay(date, today)) dayBtn.classList.add("is-today");
          if (sameDay(date, selected)) dayBtn.classList.add("is-on");
          dayBtn.addEventListener("click", function () { choose(date); });
          days.appendChild(dayBtn);
        })(day);
      }
    }

    function open() {
      closeAll(null);
      panel.hidden = false;
      root.setAttribute("data-open", "");
      btn.setAttribute("aria-expanded", "true");
      render();
      panel.classList.remove("is-floating");
      panel.style.removeProperty("top");
      panel.style.removeProperty("left");
      var panelRect = panel.getBoundingClientRect();
      if (panelRect.bottom > window.innerHeight - 12) {
        var btnRect = btn.getBoundingClientRect();
        var siteHeader = document.querySelector("[data-lv-header]");
        var headerBottom = siteHeader ? siteHeader.getBoundingClientRect().bottom : 0;
        var safeTop = Math.max(headerBottom + 12, window.innerHeight - panelRect.height - 12);
        var safeLeft = Math.max(12, Math.min(btnRect.left, window.innerWidth - panelRect.width - 12));
        panel.classList.add("is-floating");
        panel.style.top = safeTop + "px";
        panel.style.left = safeLeft + "px";
      }
    }

    function close(focusBtn) {
      panel.hidden = true;
      root.removeAttribute("data-open");
      btn.setAttribute("aria-expanded", "false");
      panel.classList.remove("is-floating");
      panel.style.removeProperty("top");
      panel.style.removeProperty("left");
      if (focusBtn) btn.focus();
    }

    function choose(date) {
      selected = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      input.value = iso(selected);
      input.setAttribute("value", iso(selected));
      value.textContent = selected.toLocaleDateString(locale, { month: "short", day: "numeric", year: "numeric" });
      close(true);
    }

    btn.addEventListener("click", function () { panel.hidden ? open() : close(true); });
    root.querySelector("[data-lv-date-prev]").addEventListener("click", function () {
      view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
      render();
    });
    root.querySelector("[data-lv-date-next]").addEventListener("click", function () {
      view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
      render();
    });
    root.querySelector("[data-lv-date-today]").addEventListener("click", function () { choose(today); });
    root.querySelector("[data-lv-date-clear]").addEventListener("click", function () {
      selected = null;
      input.value = "";
      input.removeAttribute("value");
      value.textContent = "mm / dd / yyyy";
      close(true);
    });
    document.addEventListener("click", function (e) { if (!root.contains(e.target)) close(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) close(true); });
    render();
  });

  /* Hero search -> /collections/all filtered by tag */
  var form = document.querySelector("[data-lv-search]");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var parts = [];
      form.querySelectorAll("[data-lv-select-input]").forEach(function (s) {
        if (s.value) parts.push(s.value);
      });
      var base = form.getAttribute("data-base") || "/collections/all";
      window.location.href = parts.length ? base + "/" + parts.join("+") : base;
    });
  }
})();

/* Multi-step tailor-made form */
(function () {
  "use strict";
  var host = document.querySelector("[data-lv-steps]");
  if (!host) return;

  var steps = Array.prototype.slice.call(host.querySelectorAll(".lv-step"));
  var bar = Array.prototype.slice.call(host.querySelectorAll(".lv-steps__bar li"));
  var i = 0;

  function show(n) {
    i = Math.max(0, Math.min(n, steps.length - 1));
    steps.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
    bar.forEach(function (b, k) { b.classList.toggle("is-on", k <= i); });
    var legend = steps[i].querySelector("legend");
    if (legend) legend.setAttribute("tabindex", "-1"), legend.focus();
  }

  function valid(step) {
    var fields = step.querySelectorAll("input[required], select[required], textarea[required]");
    for (var k = 0; k < fields.length; k++) {
      if (!fields[k].checkValidity()) { fields[k].reportValidity(); return false; }
    }
    return true;
  }

  host.addEventListener("click", function (e) {
    var next = e.target.closest("[data-next]");
    var prev = e.target.closest("[data-prev]");
    if (next) { if (valid(steps[i])) show(i + 1); }
    else if (prev) { show(i - 1); }
  });
})();

/* Testimonial carousel */
(function () {
  "use strict";
  var root = document.querySelector("[data-lv-quotes]");
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll(".lv-quotes__item"));
  var dots = Array.prototype.slice.call(root.querySelectorAll(".lv-quotes__dots button"));
  var prev = root.querySelector("[data-lv-quotes-prev]");
  var next = root.querySelector("[data-lv-quotes-next]");
  if (items.length < 2) return;

  var i = 0, timer = null;
  var DELAY = 7000;

  function show(n) {
    i = (n + items.length) % items.length;
    items.forEach(function (el, k) {
      el.classList.toggle("is-on", k === i);
      if (k === i) el.removeAttribute("aria-hidden");
      else el.setAttribute("aria-hidden", "true");
    });
    dots.forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
  }
  function start() { stop(); timer = window.setInterval(function () { show(i + 1); }, DELAY); }
  function stop() { if (timer) window.clearInterval(timer); timer = null; }
  function go(n) { show(n); start(); }

  if (prev) prev.addEventListener("click", function () { go(i - 1); });
  if (next) next.addEventListener("click", function () { go(i + 1); });
  dots.forEach(function (d, k) { d.addEventListener("click", function () { go(k); }); });

  root.addEventListener("mouseenter", stop);
  root.addEventListener("mouseleave", start);
  root.addEventListener("focusin", stop);

  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) start();
})();

